"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.strings = void 0;
exports.strings = {
    time: {
        second: "ثانیه",
        minute: "دقیقه",
        hour: "ساعت",
        day: "روز",
        week: "هفته",
        before: "پیش",
        now: "الان",
        some_time: "مدتی",
        today: "امروز",
        yesterday: "دیروز",
    },
    days_remaining: "{count} روز",
};
//# sourceMappingURL=fa.js.map